import { render, staticRenderFns } from "./zhaopin.vue?vue&type=template&id=896b0742&scoped=true&"
import script from "./zhaopin.vue?vue&type=script&lang=js&"
export * from "./zhaopin.vue?vue&type=script&lang=js&"
import style0 from "./zhaopin.vue?vue&type=style&index=0&id=896b0742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896b0742",
  null
  
)

export default component.exports